module.exports = __webpack_public_path__ + "media/5.07916cc1.mp3";